import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

export const GetPatientHistoryList = async () => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/GetPatientHistoryList`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const CreateB2BRegistration = async (data) => {
    //debugger;
    //console.log(JSON.stringify(data))
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `B2BRegistration/CreateRegistration`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}


export const UploadAttachment = async (attachment) => {
    //console.log("attchment: ", attachment)
    //debugger;
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `B2BRegistration/UploadAttachment`, attachment)).then(response => response);
    return result;
}

export const View_UploadedFile = async (url) => {
    //console.log("attchment: ", url)
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/View_UploadedFile?url=${url}`)).then(response => response);
    return result;
}


export const GetTestTATbyTestCode = async (data) => {
    //debugger;
    //console.log(JSON.stringify(data))
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `B2BRegistration/GetTestTATbyTestCode`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}


export const UniversalSearchTestDetailByTestCode = async (data) => {
    //debugger;
    //console.log(JSON.stringify(data))
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `B2BRegistration/UniversalSearchTestDetailByTestCode`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}


export const GetOrgLocationListByOrgId = async (orgId) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/GetOrgLocationListByOrgId?orgId=${orgId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetAttachmentOptionList = async () => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/GetAttachmentOptionList`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}


export const GetTestSampleAndContainerDetailList = async (data) => {
    //debugger;
    //console.log(JSON.stringify(data))
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `B2BRegistration/GetTestSampleAndContainerDetailList`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetAccountBalanceDetails = async (clientCode) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/GetAccountBalanceDetails?clientCode=${clientCode}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPincodeStateDetails = async (pincode) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/GetPincodeStateDetails?pincode=${pincode}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}


export const ValidateContainerBarcodeId = async (container, barcodeId) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/ValidateContainerBarcodeId?containerType=${container}&barcodeId=${barcodeId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetSalutationList = async (gender) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/GetSalutationList?gender=${gender}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}



export const GetTRFRegistrationPDFListURL = async (trfId, orgName) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/GetTRFRegistrationPDFList?trfId=${trfId}&orgName=${orgName}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartnerFrequentAddedTestMasterList = async (partner_code) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `B2BRegistration/GetPartnerFrequentAddedTestMasterList?partner_code=${partner_code}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}
